import appContractor from "../../views/appSettings/contractor.html";
import constants from "../../core/constants";

function urlsConfig($stateProvider) {
  "ngInject";

  $stateProvider.state("contractor", {
    url: "contractor/:id",
    parent: "app",
    views: {
      view: {
        template: appContractor,
      },
    },
    reloadOnSearch: false,
    data: { title: "Contractor" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/contractor/contractor.urls.js